import { collection, orderBy, query } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { useEffect, useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";

export const useIndustries = (full) => {
  const [industries, setIndustries] = useState([]);
  const [value, loading, error] = useCollection(
    query(collection(db, "industries"), orderBy("industry", "asc"))
  );
  useEffect(() => {
    const run = () => {
      if (value) {
        const docs = value.docs.map((snap) =>
          full ? snap.data() : snap.get("industry")
        );
        setIndustries(docs);
      }
    };
    run();
  }, [value, full]);

  return { industries, loading, error };
};
